import { getCustomError } from './error';

export const checkFileSize = (file: File) => {
  //BE limit is set to 10485760, but 10485760 cant be used.
  if (file.size > 10480000) {
    throw getCustomError('fileTooLarge');
  }
};
